import type { Lesson } from "@core/grades/types";
import {
  formatDuration,
  formatNumber,
  formatRelativeTime,
  money,
  URLS,
} from "@core/shared/utils";
import { settingsAtom } from "@framework/shared/atoms";
import { trans } from "@mongez/localization";

export function useModernHomeLesson(lesson: Lesson) {
  return {
    category: lesson.category?.name,
    comments: formatNumber(lesson.comments || 0),
    duration: lesson.duration ? formatDuration(lesson.duration) : undefined,
    href: URLS.lessons.view(lesson),
    image:
      lesson.image?.url || settingsAtom.get("general")?.logo?.url || undefined,
    instructorImage: lesson.instructor?.image?.url,
    instructorName: lesson.instructor?.name,
    publishedAt: formatRelativeTime(lesson.createdAt),
    price: lesson.isFree ? trans("free") : money(lesson.cost || 0),
    rating: lesson.rating || 0,
    subject: lesson.subject?.name,
    views: formatNumber(lesson.views || 0),
  };
}
